
<div class="space-y-6">
    <!-- Header -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
            <h2 class="text-2xl font-bold text-white flex items-center gap-3">
                <i class="fa-solid fa-users-gear text-purple-500"></i> Platform Team Management
            </h2>
            <p class="text-slate-400 mt-1">Manage global staff roles including Accountants and Auditors.</p>
        </div>
        <button (click)="openInviteModal()" class="bg-purple-600 hover:bg-purple-500 text-white px-6 py-2.5 rounded-xl font-bold transition-all shadow-lg flex items-center justify-center gap-2">
            <i class="fa-solid fa-user-plus"></i>
            <span>Invite Platform Staff</span>
        </button>
    </div>

    <!-- Team List Table -->
    <div class="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden shadow-xl">
        @if(isLoading()) {
            <div class="p-20 text-center text-slate-500">
                <i class="fa-solid fa-circle-notch animate-spin text-4xl text-purple-500 mb-4"></i>
                <p>Loading team members...</p>
            </div>
        } @else {
            <div class="overflow-x-auto">
                <table class="w-full text-left text-sm text-slate-400">
                    <thead class="bg-slate-950 text-slate-300 uppercase text-xs font-semibold">
                        <tr>
                            <th class="px-6 py-4">Name & Email</th>
                            <th class="px-6 py-4">Global Role</th>
                            <th class="px-6 py-4">Status</th>
                            <th class="px-6 py-4">Joined At</th>
                            <th class="px-6 py-4 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-800">
                        @for (member of team(); track member.uid) {
                            <tr class="hover:bg-slate-800/50 transition-colors">
                                <td class="px-6 py-4">
                                    <div class="flex items-center gap-3">
                                        <div class="w-10 h-10 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center font-bold text-purple-400">
                                            {{ getInitials(member.name) }}
                                        </div>
                                        <div>
                                            <div class="font-bold text-white">{{ member.name }}</div>
                                            <div class="text-xs text-slate-500">{{ member.email }}</div>
                                        </div>
                                    </div>
                                </td>
                                <td class="px-6 py-4">
                                    <span class="px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border"
                                          [class]="getRoleColor(member.role)">
                                        {{ member.role.replace('platform_', '') }}
                                    </span>
                                </td>
                                <td class="px-6 py-4">
                                    <div class="flex items-center gap-2 text-xs font-bold" 
                                         [class.text-emerald-400]="member.status === 'active'"
                                         [class.text-slate-500]="member.status !== 'active'">
                                        <span class="w-2 h-2 rounded-full" [class.bg-emerald-500]="member.status === 'active'" [class.bg-slate-600]="member.status !== 'active'"></span>
                                        {{ member.status | uppercase }}
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-xs">
                                    {{ member.createdAt | date:'dd MMM yyyy, HH:mm' }}
                                </td>
                                <td class="px-6 py-4 text-right">
                                    <button class="text-slate-400 hover:text-white transition-colors" title="Edit (Disabled)">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                </td>
                            </tr>
                        } @empty {
                            <tr>
                                <td colspan="5" class="p-10 text-center text-slate-500">
                                    No platform staff found.
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>

<app-invite-platform-staff-modal
  [isOpen]="isInviteModalOpen()"
  (closeModal)="isInviteModalOpen.set(false)"
  (staffInvited)="loadTeam()">
</app-invite-platform-staff-modal>
